import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskLine({ children, delay = 0, className = "" }) {
    const reduce = useReducedMotion();
    return (
        <motion.span
            className={`block overflow-hidden ${className}`}
            initial={reduce ? "show" : "hidden"}
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
        >
            <motion.span
                className="block will-change-transform"
                variants={{
                    hidden: { y: "112%" },
                    show: {
                        y: 0,
                        transition: { duration: 1, ease: EASE, delay },
                    },
                }}
            >
                {children}
            </motion.span>
        </motion.span>
    );
}

export function FadeUp({ children, delay = 0, className = "", y = 28 }) {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}
